module.exports = __webpack_public_path__ + "static/media/battery.1f5f1218.svg";